enum FollowUpTime {
  ONE_DAY = "1 business day",
  TWO_DAYS = "2 business days",
  ONE_WEEK = "1 week",
  TWO_WEEKS = "2 weeks",
  ONE_MONTH = "1 month",
  THREE_MONTHS = "3 months",
  CUSTOM = "custom",
}

export default FollowUpTime;
